<template>
  <section>
    <div :style="{borderColor: $store.getters.clientStyle.primary}"
      class="global-question-card container global-question-card-padding dropdown-question"
      @mouseover="comment.questionIsFocussed=true"
      @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this question type -->
      <div class="columns global-answer-padding">

        <div class="column is-four-fifths dropdown-padding">
          <!-- <div
          v-for="(value, index) in questionData.values"
          :key="index"
          class="field radio-option">
            <b-radio
            v-model="questionData.answer"
            :native-value="index"
            size="is-medium"
            type="is-dark"
            @input="saveAnswer">
              <h3 class="is-size-5 has-text-black-ter radio-option-text">{{ value }}</h3>
            </b-radio>
          </div> -->

          <vue-dropdown
            :config="config"
            @setSelectedOption="saveAnswer($event)"
            class="dropdown">
          </vue-dropdown>

          <!-- <div class="dropdown is-hoverable" >
            <div class="dropdown-trigger">
              <button class="button" aria-haspopup="true" aria-controls="dropdown-menu3">
                <span>Click me</span>
                <span class="icon is-small">
                  <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu3" role="menu">
              <div class="dropdown-content">
                <div v-for="(value, index) in questionData.values"
                :key="index">
                  <a href="#" class="dropdown-item">
                    {{ value }}
                  </a>
                </div>
              </div>
            </div>
          </div> -->

        </div>

        <!-- button area (right side of question card) -->
        <question-options />

      </div>
    </div>

    <!-- Comment component to be redered when comments are allowed for this question -->
    <comment-box ref="commentBox" v-if="questionData.comment=='1'" />
  </section>
</template>

<script>
import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'

export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      radio: 'default',
      answer: null,
      uploads: [],
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      },
      config: {
        options: [],
        placeholder: 'Selecteer...',
        backgroundColor: '#f2f2f2',
        textColor: 'black',
        borderRadius: '5px',
        // border: '1px solid gray',
        width: 350
      }
    }
  },
  created () {
    this.questionData.values.forEach((value) => {
      let option = {}
      option.value = value
      this.config.options.push(option)
    })

    if (this.questionData.answer) {
      this.config.placeholder = this.questionData.answer
    }
  },
  methods: {
    saveAnswer (selected) {
      this.questionData.answer = selected.value
      this.config.placeholder = selected.value
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  }
}
</script>

<style scoped>

  .dropdown-question {
    z-index: 12;
  }

  .dropdown-padding {
    height: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/DropdownQuestion.vue